export const PROFILER_TOOLBAR_TAG_NAME = "profilerToolbar" as const;

export const POSITION_STORAGE_KEY = "profiler-toolbar-position";

export const OPEN_MODE_STORAGE_KEY = "profiler-open-mode";

export const WINDOW_RECTS_STORAGE_KEY = "profiler-window-rects";

export const COLLAPSED_STORAGE_KEY = "profiler-toolbar-collapsed";

export const WINDOW_SIDEBAR_WIDTH_STORAGE_KEY = "profiler-window-sidebar-width";
